import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component that adds appointment events to the device calendar.
// On native, sends data to the CalendarComponent which opens the calendar app.
// On web, navigates to the .ics download URL as a fallback.

export default class extends BridgeComponent {
  static component = "calendar"
  static values = {
    title: String,
    startsAt: String,
    location: String,
    description: String,
    icsUrl: String,
  }

  add(event) {
    if (this.enabled) {
      event?.preventDefault()
      this.send("add", {
        title: this.titleValue,
        startsAt: this.startsAtValue,
        location: this.locationValue,
        description: this.descriptionValue,
      })
    }
    // On web, let the link navigate to the .ics URL naturally
  }
}
